import { type PropsWithChildren } from 'react'
import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Toolbar as MuiToolbar,
} from '@mui/material'
import { type DataTestIdAttribute } from '../../types'
import { useEnvironmentBackgroundColor } from './use-environment-background-color'

import { type Environment } from './type-environment'

export type ToolbarProps = PropsWithChildren<{
  /**
   * You can pass the environment when you need the same colouring as our AppHeader
   */
  environment?: Environment

  /**
   * In most cases you do want to have this color scheme of our Appheader
   * @default false
   */
  isNotTransparent?: boolean

  /**
   * In some cases you do not want to print the toolbar at all
   * @default false
   */
  noPrint?: boolean
}> &
  DataTestIdAttribute

/**
 * Toolbar
 *
 * Our toolbar, make sure to only place `small` items not medium or large!
 *
 * Demos:
 * - [Toolbar](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-toolbar--docs)
 *
 */
export const Toolbar = ({ children, environment, isNotTransparent = false, noPrint, ...rest }: ToolbarProps) => {
  const color = useEnvironmentBackgroundColor(environment)

  return (
    <MuiToolbar
      {...rest}
      sx={{
        backgroundColor: isNotTransparent ? color.bgColor : undefined,
        color: isNotTransparent ? color.color : 'inherit',
        '@media print': { px: 0, ...(noPrint && { display: 'none' }) },
      }}
    >
      {children}
    </MuiToolbar>
  )
}
